import React from "react";

const Welcome = () => <>
<h1>Welcome to the Public Talks Organiser</h1>
<p>For Jehovah's Witnesses</p>

Already have an account?&nbsp;<a href="/login">Login Here</a>
</>

export default Welcome;